module.exports = __webpack_public_path__ + "static/media/vipExplain.1c097333.png";